import { render, staticRenderFns } from "./GarageSchedule.vue?vue&type=template&id=04010b0c&scoped=true&"
import script from "./GarageSchedule.vue?vue&type=script&lang=js&"
export * from "./GarageSchedule.vue?vue&type=script&lang=js&"
import style0 from "./GarageSchedule.vue?vue&type=style&index=0&id=04010b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04010b0c",
  null
  
)

export default component.exports